import React from 'react';
import classNames from 'classnames';
import './Status.scss';

interface IStatusProps {
  icon: React.ReactNode;
  label: string | React.ReactElement;
  severity?: string;
  hideLabel?: boolean;
}

const Status = ({ icon, label, severity, hideLabel = false }: IStatusProps) => (
  <div
    className={classNames('status', {
      [`status--${severity}`]: severity,
    })}
  >
    <span className="status__icon">{icon}</span>
    {!hideLabel && <span className={'status__label'}>{label}</span>}
    {hideLabel && <div className={'status__tooltip'}>{label}</div>}
  </div>
);

export default Status;
